import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { ROUTE_PROFILE, ROUTE_EDIT_PROFILE, ROUTE_EDIT_PROFILE_CURRENT } from '../../../constants/routeconstants';
import Avatar from '../../reusable/image/Avatar';
import * as UserActions from '../../../actions/user';
import UserRoles from '../../../../../common/src/enums/UserRoles';

class ProfilePage extends React.Component {

    static getId() {
        return ROUTE_PROFILE;
    }

    static getAllowedRoles() {
        //return [UserRoles.USER, UserRoles.ADMIN];
        return []; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            user: null
        }
    }

    componentDidMount() {
        this.loadUser(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params.userId !== this.props.params.userId) this.loadUser(nextProps);
        else {
            const userId = this.getUserId(nextProps);
            const user = nextProps.user.users.get(userId);
            if (user) this.setState({user: user});
        }
    }

    loadUser = props => {
        const userId = this.getUserId(props);
        const user = this.props.user.users.get(userId);
        if (!user) {
            this.props.dispatch(UserActions.getUser(userId, this.props.auth.roleId & UserRoles.ADMIN.id));
            this.setState({user: null});
        }
        else this.setState({user: user});
    }

    render() {
        const user = this.state.user;
        return (
            <div className="user-profile-page">
                {user ? [
                    <div className="sub-page-title" key="title">
                        <h1>User profile</h1>
                        <div className="actions">
                            {user.id === this.props.auth.userId || this.props.auth.roleId & UserRoles.ADMIN.id ?
                                <button type="submit" className="btn-primary" onClick={e => {
                                    e.preventDefault();
                                    if (user.id == this.props.auth.userId) this.props.dispatch(push(ROUTE_EDIT_PROFILE_CURRENT));
                                    else this.props.dispatch(push(ROUTE_EDIT_PROFILE.replace(":userId", user.id)))
                                }}>Edit</button> : ''}
                        </div>
                    </div>,
                    <div className="sub-page-content" key="content">
                        <div className="column half-width">
                            <p>{user.firstName + ' ' + user.lastName}</p>
                            <p>Email: <a href={'mailto:' + user.email}>{user.email}</a></p>
                        </div>
                        <div className="column half-width">
                            <Avatar userId={user.id} size="big" link={false}/>
                        </div>
                    </div>
                ] : ''}
            </div>
        );
    }

    getUserId = newestProps => {
        const userId = Number(newestProps.params.userId) || newestProps.auth.userId || null;
        if (userId === null) console.error("user not detected"); // should never happen during normal flow (maybe redirect to login-page in that case?)
        return userId;
    };
}

const mapStateToProps = (state) => ({
    user: {
        users: state.user.users
    },
    auth: state.auth
});

export default connect(mapStateToProps)(ProfilePage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/profile/ProfilePage.js